import React, { useMemo, useState } from "react";
import dayjs from "dayjs";
import TestSvgIcon from "../../../Svg/TestSvgIcon";
import Table from "../../CommonComponents/Table";

/* Replace with your chevron svg if needed */
const ChevronDown = () => <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none"><path d="M1 1L7 7L13 1" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
const ChevronUp = () => <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none"> <path d="M13 7L7 1L1 7" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>;

export default function UserActivityReportTable({ activityData }) {

  // console.log("activities", activityData);

  /* 🔹 Expanded rows state */
  const [expandedDates, setExpandedDates] = useState({});

  const toggleDate = (date) => {
    setExpandedDates((prev) => ({
      ...prev,
      [date]: !prev[date],
    }));
  };

  /* 🔹 Transform API data for Table */
  const tableData = useMemo(() => {
    const rows = [];
    
    // Use prop data with null/undefined checks
    const dataToUse = activityData && Array.isArray(activityData) ? activityData : [];

    dataToUse.forEach((day) => {
      const hasActivities = day.activities?.length > 0;
      const isExpanded = expandedDates[day.activityDate];

      rows.push({
        type: "date",
        activityDate: day.activityDate,
        firstLoginTime: day.firstLoginTime,
        hasActivities,
        isExpanded,
      });

      if (hasActivities && isExpanded) {
        day.activities.forEach((act) => {
          rows.push({
            type: "activity",
            parentDate: day.activityDate,
            name: act.name,
            lpname: act.lpname,
            timespent: act.totalTimeSpent,
            accessedtime: act.firstAccessedTime,
            libtype: act.libtype
          });
        });
      }
    });

    return rows;
  }, [activityData, expandedDates]);

  /* 🔹 Table columns */
  const headerCells = [
    { key: "activity", title: "Activity" },
    { key: "timespent", title: "Time Spent" },
    { key: "accessedtime", title: "Accessed Time" },
  ];

  /* 🔹 Custom row rendering */
  const renderCustomRow = (row, index) => {
    /* Date row */
    if (row.type === "date") {
      return (
        <tr
          key={index}
          className={`activityDateRow ${index %2 === 0 ? "evenRow" : "oddRow"} ${row.isExpanded ? "expanded" : ""}`}
          onClick={() =>
            row.hasActivities && toggleDate(row.activityDate)
          }
        >
          <td colSpan={3} className="dateRowCell">
            <div className="dateRowContent">
              <span>
                {dayjs(row.activityDate).format("DD/MM/YYYY")}
                {" | "}
                {row.firstLoginTime
                  ? `Login - ${dayjs(row.firstLoginTime).format("hh:mm a")}`
                  : "Inactive"}
              </span>

              {row.hasActivities && (
                <span className="chevronIcon">
                  {row.isExpanded ? <ChevronUp /> : <ChevronDown />}
                </span>
              )}
            </div>
          </td>
        </tr>
      );
    }

    /* Activity row */
    return (
      <tr key={index} className={`activityItemRow ${index}`}>
        <td className="activityItemContainer">
          <div className="activityNameCell">
            <div className="activityIcon">
              <TestSvgIcon
                active={true}
                disable={false}
                libType={row.libtype}
              />
            </div>
            <div>
              <div className="activityName">{row.name}</div>
              <div className="lpName">{row.lpname}</div>
            </div>
          </div>
        </td>
        <td className="timespent">{row.timespent}m</td>
        <td className="accessedtime">{dayjs(row.accessedtime).format("hh:mm a")}</td>
      </tr>
    );
  };

  return (
    <div className="userActivityReportTable">
      <Table
        columns={headerCells}
        data={tableData}
        fixedHeader={true}
        renderRow={renderCustomRow}
        emptyText="No records found"
      />
    </div>
  );
}
